// src/features/equipment/components/maintenance/MaintenanceStatusChip.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import { format } from 'date-fns';
import { parseApiTimestamp } from '../../../../utils/formatters/dateFormatter';
import { getDateLocale } from '../../../../i18n/LocalizedDateDistance';

const CASE_STATUS_COLORS = {
  reported: 'warning',
  in_progress: 'info',
  completed: 'success',
  cancelled: 'default',
};

export default function MaintenanceStatusChip({ status, size = 'small' }) {
  const { t } = useTranslation(['equipment']);
  return (
    <Chip
      label={t(`equipment:maintenance.case_status.${status}`)}
      size={size}
      color={CASE_STATUS_COLORS[status] || 'default'}
      variant={status === 'in_progress' || status === 'reported' ? 'filled' : 'outlined'}
    />
  );
}

/** "12. sep. 2026 14:05" in the user's language. */
export function useFormatDateTime() {
  const { i18n } = useTranslation();
  return (value) => {
    const date = parseApiTimestamp(value);
    return date ? format(date, 'PP p', { locale: getDateLocale(i18n.language) }) : '';
  };
}
